<template>
  <div class="cell-delete-dialog">
    <vs-popup
      class="pm-popup cell-renderer-delete-popup"
      title="登録データの削除"
      :active="popupActive"
      @close="onClose"
    >
      <p class="confirm-text aisea-text-14-600-gray-black">
        選択した項目を削除しますか？
      </p>
      <div class="button-area">
        <vs-button class="popup-button" color="#2E87B9" @click="onCancel"
          >キャンセル</vs-button
        >
        <vs-button class="popup-button" color="#2E87B9" @click="onDelete"
          >削除</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
const EVENTS = {
  CLOSE: "close",
  CANCEL: "cancel",
  DELETE: "delete",
};

/*
 * 入出港予定一覧画面（白色ではなく黒色画面）で、行を削除するためのポップアップ
 */

export default {
  name: "DeleteTaskDialog",
  props: {
    popupActive: { type: Boolean, required: true },
  },
  methods: {
    onClose() {
      this.$emit(EVENTS.CLOSE);
    },
    onCancel() {
      this.$emit(EVENTS.CANCEL);
    },
    onDelete() {
      this.$emit(EVENTS.DELETE);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";

.pm-popup {
  user-select: none; /* 選択を禁止する */
  ::v-deep .vs-popup {
    width: 500px;
    background-color: #f0f0f0 !important;
  }
  header {
    h3 {
      text-align: center;
      background-color: $pm-white;
      width: 100%;
      position: relative;
      font-family: "Hiragino Kaku Gothic ProN";
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      align-items: center;
      color: #4f4f4f;
    }

    background-color: $pm-white;
  }

  .vs-popup--close {
    background-color: $pm-white !important;
    transform: translate(-10px, 10px);
    &:hover {
      transform: translate(-10px, 8px);
    }
  }

  .confirm-text {
    text-align: center;
  }
  .popup-button {
    flex: 1;
    font-weight: 600;
    font-size: 16px;
  }
  .button-area {
    padding: 0 14px;
    width: 100%;
    height: 46px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    column-gap: 28px;
  }
}
</style>
